import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  getTestSetups(payload) {
    return axios
      .get(`${URL}/test_setups`, { ...payload })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
};
